import { useEffect, useRef, useState } from 'react';
import MqttMsgEdit from './MqttMsgEdit';
import WebUniversal, { getService, WebUniversalProps } from '../../system/WebUniversal';
import { columnsheadId } from '../../../utilsTsx/components/system/columnshead';
import { Space, Tag, Tooltip } from 'antd';
import CustomSelect from '../../../utilsTsx/components/hooks/CustomSelect';
import fetchApi from '../../../utilsTsx/components/system/fetchApi';
import dayjs from 'dayjs';

const WebComponent = (props: any) => {
    const ref = useRef<any>(undefined);
    const apiId = 'mqttMsg';

    const [fetchData, setFetchData] = useState<any>();
    const [sendPageData, setSendPageData] = useState<any>();
    const [senderDeviceData, setSenderDeviceData] = useState<any>();
    const [topicData, setTopicData] = useState<any>();
    const [sendTargetData, setSendTargetData] = useState<any>();

    useEffect(() => {
        let urlService;
        if (ref.current) {
            urlService = ref.current.defaultService;
            setFetchData(() => ref.current.fetchData);
        }

        // 设备列表（用于筛选下拉）
        fetchApi.GET(urlService, {
            query: {
                apiId: 'device',
                apiExtend: 'showList'
            }
        }).then(res => {
            if (res.success) {
                setSenderDeviceData([{ id: 'ALLITEM', deviceName: '所有设备' }, ...res.data]);
            }
        });

        // 主题列表（用于筛选下拉）
        fetchApi.GET(urlService, {
            query: {
                apiId: 'topic',
                apiExtend: 'showList'
            }
        }).then(res => {
            if (res.success) {
                setTopicData([{ id: 'ALLITEM', topicName: '所有' }, ...res.data]);
            }
        });

        // 发送目标枚举（bm 服务）
        fetchApi.GET(getService('bm'), {
            query: {
                apiId: 'generalData',
                apiVariable: 'sendTarget',
                apiExtend: 'showLists'
            }
        }).then(res => {
            if (res.success) {
                const { sendTarget } = res.data;
                setSendTargetData([{ id: 'ALLITEM', name: '所有' }, ...(sendTarget || [])]);
            }
        });
    }, []);

    // 表头
    const columnsHead = [
        {
            title: '发送设备',
            dataIndex: ['senderDevice', 'deviceName'],
            render: (val: string) => val || '-'
        },
        {
            title: '主题id',
            dataIndex: ['topic', 'topicName'],
            render: (val: string) => val || '-'
        },
        {
            title: '主题',
            dataIndex: 'topicStr'
        },
        {
            title: '目标',
            dataIndex: ['sendTarget', 'name'],
            render: (val: any) => val ? <Tag color="blue">{val}</Tag> : '-'
        },
        {
            title: 'msgId',
            dataIndex: 'msgId'
        },
        {
            title: '信息',
            dataIndex: 'originalMsg',
            render: (val: string) =>
                val
                    ? <Tooltip placement="topLeft" title={val}>
                        {val.length >= 30 ? val.substring(0, 30) + '......' : val}
                    </Tooltip>
                    : '-'
        },
        {
            title: '创建时间',
            dataIndex: ['sysDate', 'createdAt'],
            render: (val: string) =>
                val ? dayjs(val).format('YYYY-MM-DD HH:mm:ss') : '-'
        }
    ];

    const columns = columnsheadId.concat(columnsHead as []);

    let extendProps: WebUniversalProps = {
        ...props,
        titleName: 'MQTT消息',
        apiId,
        columns,
        serviceId: 'mf',
        displayOptions: {
            showStates: {
                title: '发送',
                columnName: 'isSendSuccess',
                checkedChildren: '成功',
                unCheckedChildren: '失败',
            },
            showDefault: {
                title: '接收',
                columnName: 'isReceiveSuccess',
                checkedChildren: '成功',
                unCheckedChildren: '失败',
            }
        },
        editOptions: {
            Editor: MqttMsgEdit
        }
    };

    return (
        <>
            <Space>
                <CustomSelect
                    apiId={apiId}
                    sendKeyId='senderDeviceId'
                    getListData={senderDeviceData}
                    sendPageData={sendPageData}
                    setSendPageData={setSendPageData}
                    fetchData={fetchData}
                    itemName="deviceName"
                />
                <CustomSelect
                    apiId={apiId}
                    sendKeyId='topicId'
                    getListData={topicData}
                    sendPageData={sendPageData}
                    setSendPageData={setSendPageData}
                    fetchData={fetchData}
                    itemName='topicName'
                />
                <CustomSelect
                    apiId={apiId}
                    sendKeyId='sendTargetId'
                    getListData={sendTargetData}
                    sendPageData={sendPageData}
                    setSendPageData={setSendPageData}
                    fetchData={fetchData}
                />
            </Space>
            <> </>
            <WebUniversal {...extendProps} ref={ref} />
        </>
    );
};

export default WebComponent;